



































































































































































import { Component, Vue } from "vue-property-decorator";
import Sparkline from "vue-sparklines";
import { Store } from "vuex";
import { store } from "@/store";
import {
  readHasAdminAccess,
  readWithdraws,
  readWithdrawStateName,
  readHasAccountantAccess,
  readImage
} from "@/store/main/getters";
import { readAdminOneUser } from "@/store/admin/getters";
import { dispatchGetUsers } from "@/store/admin/actions";
import {
  dispatchGetWithdraws,
  dispatchGetWithdrawStates,
  dispatchGetWithdrawRecipetImage
} from "@/store/main/actions";
import { readCurrencyName, readUserOneWallet } from "@/store/wallet/getters";
import {
  dispatchGetCurrencies,
  dispatchGetWallets
} from "@/store/wallet/actions";

@Component({
  components: {
    Sparkline
  }
})
export default class Withdraws extends Vue {
  public headers = [
    {
      text: "نوع",
      sortable: true,
      value: "type",
      align: "right"
    },
    {
      text: "برداشت شده",
      sortable: true,
      value: "from_amount",
      align: "right"
    },
    {
      text: "ارز برداشتی",
      sortable: true,
      value: "currency",
      align: "right"
    },
    {
      text: "مقصد",
      sortable: true,
      value: "to_wallet_id",
      align: "right"
    },
    {
      text: "دریافتی نهایی",
      sortable: true,
      value: "to_amount",
      align: "right"
    },
    {
      text: "ارز دریافتی",
      sortable: true,
      value: "to_currency",
      align: "right"
    },
    {
      text: "وضعیت",
      sortable: true,
      value: "state",
      align: "right"
    },
    {
      text: "زمان درخواست",
      sortable: true,
      value: "request_datetime",
      align: "right"
    },
    {
      text: "زمان انجام",
      sortable: true,
      value: "done_datetime",
      align: "right"
    },
    {
      text: "قیمت واحد",
      sortable: true,
      value: "unit_price",
      align: "right"
    },
    {
      text: "رسید",
      sortable: true,
      value: "reciept",
      align: "right"
    }
  ];

  public fetched = false;

  public recieptImageUrl = "";

  public TYPE_TRANSFER = 1;
  public TYPE_WITHDRAW = 2;
  public type = this.TYPE_WITHDRAW;

  get withdraws() {
    const withdraws = readWithdraws(this.$store);
    return withdraws;
  }

  public getUserName(user_id: number) {
    const user = readAdminOneUser(this.$store)(user_id);
    if (!user) {
      return "----";
    }
    let name = user.id.toString() + "-";
    if (user.full_name) name += user.full_name;
    else if (user.mobile) name += user.mobile;
    else if (user.email) name += user.email;

    return name;
  }

  public showBalance(balance: number, currencyId: number) {
    if (readCurrencyName(this.$store)(currencyId) === "ETH") {
      if (balance) return `${(balance / 10 ** 18).toFixed(5)}`;
      return "0";
    }else if (readCurrencyName(this.$store)(currencyId) === "ETC") {
      if (balance) return `${(balance / 10 ** 18).toFixed(5)}`;
      return "0";
    }else if (readCurrencyName(this.$store)(currencyId) === "ZIL") {
      if (balance) return `${(balance / 10 ** 12).toFixed(5)}`;
      return "0";
    }else if (readCurrencyName(this.$store)(currencyId) === "XCH") {
      if (balance) return `${(balance / 10 ** 12).toFixed(5)}`;
      return "0";
    }else if (readCurrencyName(this.$store)(currencyId) === "XCC") {
      if (balance) return `${(balance / 10 ** 8).toFixed(5)}`;
      return "0";
    } else if (readCurrencyName(this.$store)(currencyId) === "IRT") {
      if (balance) return `${(+balance.toFixed(0)).toLocaleString()}`;
      return "0";
    }
    return balance;
  }

  public readImage(image_blob: Blob) {
    return new Promise<string | ArrayBuffer | null>(resolve => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(image_blob);
    });
  }

  public async showModal(reciept: string, withdrawId: number) {
    if (!reciept) return;
    if (reciept.startsWith("0x")) {
      const link = "https://etherscan.io/tx/" + reciept;
      // const routeData = this.$router.resolve({ name: link });
      window.open(link, "_blank");
    } else {
      await dispatchGetWithdrawRecipetImage(this.$store, {
        withdrawId: withdrawId
      });
      const blob = readImage(this.$store);
      if (blob) {
        const result = await this.readImage(blob);
        if (typeof result === "string") {
          this.recieptImageUrl = result;
          this.$bvModal.show("modalreciept");
        }
      }
    }
  }

  public showPrice(price: number) {
    if (price) return `${(+price.toFixed(0)).toLocaleString()}`;
    return "-";
  }

  public txLink(reciept: string, id: number) {
    if (!reciept) return "";
    if (reciept.startsWith("0x")) return "https://etherscan.io/tx/" + reciept;
    else return "/api/v1/withdraws/reciept/" + id;
  }

  public getCurrencyName(currencyId: number) {
    return readCurrencyName(this.$store)(currencyId);
  }

  public getCurrency(walletId: number) {
    const wallet = readUserOneWallet(this.$store)(walletId);
    if (wallet) return wallet.currency;
    return -1;
  }

  public getWalletCurrencyName(walletId: number) {
    const wallet = readUserOneWallet(this.$store)(walletId);
    if (wallet) return readCurrencyName(this.$store)(wallet.currency);
    return "-";
  }
  public getDestinationName(walletId: number, mobile) {
    const wallet = readUserOneWallet(this.$store)(walletId);
    if(wallet)
      return wallet?.name;
    else
      return mobile
  }
  public getStateName(stateId: number) {
    return readWithdrawStateName(this.$store)(stateId);
  }
  public getColor(stateId: number) {
    if (
      readWithdrawStateName(this.$store)(stateId) === "COMPLETED" ||
      readWithdrawStateName(this.$store)(stateId) === "MANUAL_SETTLEMENT"
    )
      return "color:green";
    else if (
      readWithdrawStateName(this.$store)(stateId) === "REJECTED" ||
      readWithdrawStateName(this.$store)(stateId) === "FAILED"
    )
      return "color:red";
    return "color:blue";
  }

  public summerize(str) {
    if (!str) {
      str = "----";
    }
    if (str?.length > 12) {
      str = str?.substring(0, 12) + "...";
    }
    return str;
  }

  public is_admin() {
    return readHasAdminAccess(store);
  }

  public actionType(walletId){
    if(walletId == null)
      return this.TYPE_TRANSFER
    else
      return this.TYPE_WITHDRAW
  }

  public async mounted() {
    const promises: Promise<void>[] = [
      dispatchGetWithdraws(this.$store),
      dispatchGetCurrencies(this.$store),
      dispatchGetWallets(this.$store),
      dispatchGetWithdrawStates(this.$store)
    ];
    if (readHasAdminAccess(store) && readHasAccountantAccess(store)) {
      promises.push(dispatchGetUsers(this.$store));
      this.headers.splice(0, 0, {
        text: "ID",
        sortable: true,
        value: "id",
        align: "right"
      });
      this.headers.splice(12, 0, {
        text: "کاربر",
        sortable: true,
        value: "from_user_id",
        align: "right"
      });
      this.headers.splice(13, 0, {
        text: "عملیات",
        sortable: false,
        value: "edit",
        align: "right"
      });
    }
    await Promise.allSettled(promises);

    this.fetched = true;
  }
}
